// extracted by mini-css-extract-plugin
export default {"root":"DialogNew_root__mZKJn"};